module.exports = __webpack_public_path__ + "img/img1_13.555faa29.jpeg";